document.querySelectorAll(".share-button").forEach(function (shareButton) {
  shareButton.addEventListener("click", function () {
    var product_title = this.getAttribute("product_title"),
        product_link = this.getAttribute("product_link");
    if (navigator.share) {
      navigator
        .share({
          title: product_title,
          text: product_title,
          url: product_link,
        })
        .then(() => console.log("Thanks for sharing!"))
        .catch(console.error);
    } else {
      alert("Sharing not supported on this device");
    }
  });
});

document.addEventListener('DOMContentLoaded', function () {
  Object.keys(localStorage).forEach(function(key) {
    if (key.startsWith('lineitems_')) {
      localStorage.removeItem(key);
    }
  });
});

window.globalFunction = {
  update_lineitems(){
    document.querySelectorAll('select.single_lineitems').forEach(function(single_lineitems) {
      var single_lineitemsID = single_lineitems.getAttribute('name'),
          storageKey = `lineitems_${single_lineitemsID}`,
          storedValue = localStorage.getItem(storageKey);
      
      if (storedValue && single_lineitems.value !== storedValue) {
        single_lineitems.value = storedValue;
        if(single_lineitems.value !== storedValue){
          single_lineitems.selectedIndex = 0;
        }
      }else{
        single_lineitems.selectedIndex = 0;
      }
      
      // single_lineitems.dispatchEvent(new Event('change', { bubbles: true }));
      
      single_lineitems.addEventListener('change', function(){
        localStorage.setItem(storageKey, this.value);
      });
    });

    document.querySelectorAll('input[type="radio"].color-lineitem').forEach(radio => {
      const key = `lineitems_${radio.name}`;
      const saved = localStorage.getItem(key);

      if (saved && radio.value === saved) {
        radio.checked = true;
        radio.closest(".single_option.lineitems_inner").querySelector(".variant-option__current").innerHTML = ': ' + radio.value;
      }

      radio.addEventListener('change', () => {
        if (radio.checked) {
          localStorage.setItem(key, radio.value);
        }
      });
    });
  },
  
  new_zoom_product_meida(){
    if(document.querySelector(".new_zoom_product_modal .product_media_thumb") && document.querySelector(".new_zoom_product_modal .product_media_main")){
       let thumbSwiper = new Swiper(".new_zoom_product_modal .product_media_thumb", {
        loop: true,
        spaceBetween: 0,
        slidesPerView: 5,
        freeMode: true,
        watchSlidesProgress: true,
        direction: 'horizontal',
        breakpoints: {
          768: {
            direction: 'vertical',
          }
        }
      });
    
      let mainSwiper = new Swiper(".new_zoom_product_modal .product_media_main", {
        loop: true,
        spaceBetween: 10,
        effect: 'fade',
        // autoHeight: true,
        slidesPerView: "auto",
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        thumbs: {
          swiper: thumbSwiper,
        },
      });
      
      if(document.querySelector(".product-information__media .product-media")){
        document.querySelectorAll(".product-information__media .product-media *").forEach(function(single_media){
          single_media.addEventListener('click', function(){
            var data_meida_ID = parseInt(this.closest('.product-media').getAttribute('data-media-id')),
                match_index = parseInt(this.closest('.product-information__grid').querySelector('.new_zoom_product_modal .product_media_main .swiper-slide[data_meida_ID="'+ data_meida_ID +'"]').getAttribute('index'));
            mainSwiper.slideTo(match_index, 0);
            this.closest('.product-information__grid').querySelector('.new_zoom_product_modal').classList.remove('hidden');
          });
        });
      }
      window.globalFunction.initImageZoom();
    }
  },
  initImageZoom(){
    if(document.querySelector('.product_media_main .zoom-image-wrapper')){
      document.querySelectorAll('.product_media_main .zoom-image-wrapper').forEach(wrapper => {
        var img = wrapper.querySelector('.zoom-image');
        var overlay = wrapper.querySelector('.zoom-overlay');
    
        wrapper.addEventListener('click', function (e) {
          console.log("calll");
          var zoomed = overlay.style.opacity === '1';
          overlay.style.opacity = zoomed ? '0' : '1';
          overlay.style.backgroundImage = `url(${img.src})`;
        });
    
        wrapper.addEventListener('mousemove', function (e) {
          if (overlay.style.opacity !== '1') return;
    
          var rect = wrapper.getBoundingClientRect();
          var x = ((e.clientX - rect.left) / rect.width) * 100;
          var y = ((e.clientY - rect.top) / rect.height) * 100;
          overlay.style.backgroundPosition = `${x}% ${y}%`;
        });
    
        wrapper.addEventListener('mouseleave', function () {
          overlay.style.opacity = '0';
        });
      });
    }
  }
  
};

window.globalFunction.update_lineitems();
window.globalFunction.new_zoom_product_meida();


if(document.querySelector('.new_zoom_product_modal .close_button')){
  document.querySelector('.new_zoom_product_modal .close_button').addEventListener('click', function(){
    this.closest('.new_zoom_product_modal').classList.add('hidden');
  });
}

document.querySelectorAll('.tab-faqs .single_heading').forEach(function(single_heading){
  single_heading.addEventListener('click', function(){
    var data_title = this.getAttribute('data_title');
    document.querySelectorAll('.faqs_main_title_header .single_heading').forEach(function(single_heading){
      single_heading.classList.remove("active");
    });
    this.closest(".tab-faqs").querySelectorAll(".faqs_list_inner").forEach(function(singleFaqsList){
      singleFaqsList.classList.add("hidden");
    });
    this.classList.add("active");
    this.closest(".tab-faqs").querySelector(".faqs_list_inner[data_title='"+data_title+"']").classList.remove("hidden");
  });
});

// CWI CODE J

if ($(".customer_reviews .review_list_slider").length) {
  $(".customer_reviews .review_list_slider").each(function(index, review_grid) {
    let review_grid_Swiper = new Swiper(review_grid, {
      loop: true,
      slidesPerView: 4,
      spaceBetween: 24,
      navigation: {
        nextEl: $(review_grid).closest(".customer_reviews").find(".next_arrow")[0],
        prevEl: $(review_grid).closest(".customer_reviews").find(".prev_arrow")[0],
      },   
      pagination: {
        el: $(review_grid).closest(".customer_reviews").find(".review_dot")[0],
        clickable: true,
      },        
      breakpoints: {
        1280: {
          slidesPerView: 4,
        },    
        990: {
          slidesPerView: 3,
        },         
        750: {
          slidesPerView: 2,
        },
        0: {
          slidesPerView: 1,
        },        
      },      
    });
    $(".customer_reviews").removeClass("hidden");
  });
}

if ($(window).width() <= 749 && $(".quarterly_results .main_tab_inner").length) {
  $(".quarterly_results .main_tab_inner").each(function () {
    var $single_tab = $(this),
        tab_index = parseInt($single_tab.attr("main_tab")),
        $html = $(".quarterly_results .data_information[main_tab_content='" + tab_index + "']");
    
    if ($html.length && !$($html).find('.sub_tab_content').length) {
      $html.insertAfter($single_tab);
    }
    
    if($(this).hasClass("sub_tab_inner")){
      $(this).find(".sub_tab_heading").each(function () {
        var $single_sub_tab = $(this),
            $tab_index = parseInt($single_sub_tab.attr("sub_tab")),
            $sub_html = $(".quarterly_results .data_information[main_tab_content='" + tab_index + "'] .sub_tab_content[sub_tab_content='" + $tab_index + "']");
        
        if ($sub_html.length) {
          $sub_html.insertAfter($single_sub_tab);
        }
      });
    }
    
  });
}

$(document).on("click", ".quarterly_results .quarterly_results_inner .main_data_tab .main_tab_inner", function(){
  var main_tab = $(this).attr("main_tab");
  var tab_content = $(this).parents(".content");
  var all_tab = tab_content.find('.data_information:not([main_tab_content="'+ main_tab +'"])');
  var tab_heading = $(this).find(".main_title_JS").text();
  $(".quarterly_results .quarterly_results_inner .section_heading").text(tab_heading);
  
  $('.quarterly_results .quarterly_results_inner .main_data_tab .main_tab_inner').removeClass("active");

  if (all_tab.length === 0) {
    all_tab.addClass('hidden');
  } else {
    $(this).addClass("active");
    all_tab.addClass('hidden');
    tab_content.find('.data_information[main_tab_content="'+ main_tab +'"]').removeClass('hidden');
  }

  if (!($(window).width() <= 749)){
    $('html, body').animate({
      scrollTop: ($(".quarterly_results .quarterly_results_inner .main_tab_content").offset().top - ($("#header-group header.header-section").height() + $(".quarterly_results .quarterly_results_inner .section_heading").outerHeight(true)))
    }, 500);
  }
});

$(document).on("click", ".quarterly_results .quarterly_results_inner .main_data_tab .main_tab_inner .sub_tab_heading", function(){
  var sub_tab = $(this).attr('sub_tab'),
      sub_content = $(this).parents(".content");
  
  if($(window).width() <= 749){
    $(this).toggleClass("active");
    $(this).parents(".main_tab_inner.sub_tab_inner").find(".sub_tab_heading:not([sub_tab='"+sub_tab+"'])").removeClass('active');
    $(this).parents(".main_tab_inner.sub_tab_inner").find(".sub_tab_content:not([sub_tab_content='"+sub_tab+"'])").addClass('hidden');
    $(this).next(".sub_tab_content").toggleClass('hidden');   
  }else{
    $('.quarterly_results .quarterly_results_inner .main_data_tab .main_tab_inner .sub_tab_heading').removeClass('active');
    
    var targetSubTab = sub_content.find('.sub_tab_content[sub_tab_content="' + sub_tab + '"]');
    if(targetSubTab.length === 0){
      sub_content.find('.sub_tab_content').removeClass('hidden');
    } else {
      $(this).addClass('active');
      sub_content.find('.sub_tab_content').addClass('hidden');
      targetSubTab.removeClass('hidden');
    }
  }
});

if($(window).width() <= 749 && $(".shopify-section.popular-link details.details").length){
  $(".shopify-section.popular-link details.details").removeAttr("open");
}

// CWI CODE J 

if ($(".image_slider .image_list").length) {
  $(".image_slider .image_list").each(function(index, banner_slider) {
    let banner_Swiper = new Swiper(banner_slider, {
      loop: true,
      slidesPerView: 1,     
      autoHeight: true, 
      navigation: {
        nextEl: $(banner_slider).closest(".image_slider").find(".next_arrow")[0],
        prevEl: $(banner_slider).closest(".image_slider").find(".prev_arrow")[0],
      },    
      pagination: {
        el: $(banner_slider).closest(".image_slider").find(".banner_dot")[0],
        clickable: true,
      },   
    });
    // $(".image_slider").removeClass("hidden");
  });
}

// custom js
// 12/22/2025 ==============================================================
// popup product page ============================================================

document.addEventListener('DOMContentLoaded', function () {

  const openBtn = document.getElementById('openEngravingPopup');
  const closeBtn = document.getElementById('closeEngravingPopup');
  const popup = document.getElementById('engravingPopup');
  const saveBtn = document.getElementById('saveEngraving');

  if (!popup) return;



  openBtn?.addEventListener('click', () => {
    popup.classList.add('active');
    document.body.classList.add('popup-open');
  });

  closeBtn?.addEventListener('click', () => {
    popup.classList.remove('active');
    document.body.classList.remove('popup-open');
  });

  saveBtn?.addEventListener('click', () => {
    const nameInput = document.getElementById('custom_name');
    const fontInput = document.getElementById('fontInput');
    const selectedFont = document.getElementById('selectedFont');

    if (!nameInput || nameInput.value.trim() === '') {
      alert('Please enter a name to customize');
      nameInput.focus();
      return;
    }

    fontInput.value = selectedFont.textContent;

    nameInput.dispatchEvent(new Event('change', { bubbles: true }));
    fontInput.dispatchEvent(new Event('change', { bubbles: true }));

    popup.classList.remove('active');
    document.body.classList.remove('popup-open');
  });



  const dropdown = document.querySelector('.custom-dropdown');
  const selectedFont = document.getElementById('selectedFont');
  const options = document.getElementById('fontOptions');
  const fontInput = document.getElementById('fontInput');
  const nameInput = document.getElementById('custom_name');

  if (!selectedFont || !options || !dropdown) return;

  selectedFont.addEventListener('click', (e) => {
    e.stopPropagation();

    const isOpen = options.style.display === 'block';

    options.style.display = isOpen ? 'none' : 'block';
    dropdown.classList.toggle('open', !isOpen);
  });

  options.querySelectorAll('div').forEach(option => {
    option.addEventListener('click', () => {
      const font = option.dataset.value;

      selectedFont.textContent = font;
      selectedFont.style.fontFamily = font;
      if (nameInput) nameInput.style.fontFamily = font;
      fontInput.value = font;

      options.style.display = 'none';
      dropdown.classList.remove('open');
    });
  });


  document.addEventListener('click', () => {
    options.style.display = 'none';
    dropdown.classList.remove('open');
  });

});

// popup product page ============================================================

// CWI CODE N
$(document).on("click", ".quarterly_results .quarterly_results_inner .js_trigger", function(e){
  e.preventDefault();

  var hash = $(this).attr("href");
  if(!hash) return;

  history.pushState(null, null, hash);

  quarterlyResultOpenTabs(hash, $(this).parents(".quarterly_results"));
});

function quarterlyResultOpenTabs(hash, containerMain){
  var match = hash.match(/main(\d+)(?:-sub(\d+))?/);
  if(!match) return;

  var mainTab = match[1],
      subTab = match[2],
      mainTabEl = containerMain.find('.main_tab_inner[main_tab="'+mainTab+'"]');

  if(mainTabEl.length){
    mainTabEl.click();

    var accordion = mainTabEl.find('accordion-custom summary');

    if(accordion.length){
      accordion.click();

      var subTabEl = mainTabEl.find('.sub_tab_heading[sub_tab="'+subTab+'"]');

      if(subTabEl.length){
        subTabEl.click();
      }
    }
  }
}

$(document).ready(function(){
  var hash = window.location.hash;
  if(hash){
    var containerMain = $(".quarterly_results");
    if(containerMain){
      quarterlyResultOpenTabs(hash, containerMain);
    }
  }
});